import gql from "graphql-tag";

export const GET_TITULOS_PAGINATED = gql`
query TitularesAdminPaginacionQuery($limite: Int!) {
  TitularesAdminPaginacionQuery(limite:$limite) {
    pagina,  noticias
  }
}`

/*
{
  "data": {
    "TitularesAdminPaginacionQuery": [
      {
        "pagina": "1",
        "noticias": [
          325,
          326,
          94,
          93
        ]
      }
    ]
  }
}
*/ 

export const GET_TITULOS_PAGINATED_LIST = gql`
query TitularesAdminListaQuery( $ids: [Int!]!) {
  TitularesAdminListaQuery(ids: $ids) {
    id_noticia,   titulo_noticia,   fecha_noticia,   id_estado
  }
}`

/*
{
  "data": {
    "TitularesAdminListaQuery": [
      {
        "id_noticia": 325,
        "titulo_noticia": "Prueba editando nuevo titular",
        "fecha_noticia": "2025-07-03 17:20:00",
        "id_estado": 3
      },
      {
        "id_noticia": 326,
        "titulo_noticia": "Prueba creando nuevo titular",
        "fecha_noticia": "2025-07-03 17:10:00",
        "id_estado": 1
      },
      {
        "id_noticia": 94,
        "titulo_noticia": "Región del Biobío registra 10 varamientos masivos de peces en zonas costera",
        "fecha_noticia": "2025-07-03 00:00:00",
        "id_estado": 1
      },
      {
        "id_noticia": 93,
        "titulo_noticia": "Prueba titulares",
        "fecha_noticia": "2025-07-02 00:00:00",
        "id_estado": 1
      }
    ]
  }
}
*/



// --- ModalRRSS ---
export const FIND_FEED_LIST = gql`
  query FindListasNoticias {
    FindListasNoticias {
      id_lista
      id_estado_fk
      id_empresa_fk
      noticias {
        id_lista_fk
        id_lista_noticia
        orden
        n_rss {
          id_noticia
          titulo
          fecha
        }
        n_feed {
          id_noticia
          titulo
          fecha
        }
      }
      nombre_lista
    }
  }
`;
/*
  Respuesta:
  {
    "data": {
      "FindListasNoticias": [
        {
          "id_lista": 5,
          "id_estado_fk": 1,
          "id_empresa_fk": 1,
          "noticias": [
            {
              "id_lista_fk": 5,
              "id_lista_noticia": 31,
              "orden": 1,
              "n_rss": null,
              "n_feed": {
                "id_noticia": "360",
                "titulo": "Prueba titular v100",
                "fecha": "2025-07-30T02:04:21.699Z"
              }
            },
            {
              "id_lista_fk": 5,
              "id_lista_noticia": 32,
              "orden": 2,
              "n_rss": null,
              "n_feed": {
                "id_noticia": "329",
                "titulo": "Día de la Bandera chilena: ¿qué significan sus colores y por qué tantos países también los tienen?",
                "fecha": "2025-07-10T04:00:00.000Z"
              }
            }
          ],
          "nombre_lista": "Prueba tercera"
        },
        {
          "id_lista": 4,
          "id_estado_fk": 1,
          "id_empresa_fk": 1,
          "noticias": [
            {
              "id_lista_fk": 4,
              "id_lista_noticia": 29,
              "orden": 1,
              "n_rss": null,
              "n_feed": {
                "id_noticia": "359",
                "titulo": "Prueba titular",
                "fecha": "2025-07-30T01:32:28.776Z"
              }
            },
            {
              "id_lista_fk": 4,
              "id_lista_noticia": 30,
              "orden": 2,
              "n_rss": null,
              "n_feed": {
                "id_noticia": "329",
                "titulo": "Día de la Bandera chilena: ¿qué significan sus colores y por qué tantos países también los tienen?",
                "fecha": "2025-07-10T04:00:00.000Z"
              }
            }
          ],
          "nombre_lista": "Prueba segunda"
        },
      ]
    }
  }
*/

export const GET_ALL_NEWS_TITLES = gql`
  query GetAllTitulares {
    GetAllTitulares {
      id_noticia
      titulo_noticia
      fecha_noticia
      id_estado
    }
  }
`;
/*
  Query para el input de búsqueda/creacion de titulares
  Respuesta:
  {
    "data": {
      "GetAllTitulares": [
        {
          "id_noticia": 360,
          "titulo_noticia": "Prueba titular v100",
          "fecha_noticia": "2025-07-29 22:04:00",
          "id_estado": 1
        },
        {
          "id_noticia": 359,
          "titulo_noticia": "Prueba titular",
          "fecha_noticia": "2025-07-29 21:32:00",
          "id_estado": 1
        },
        {
          "id_noticia": 358,
          "titulo_noticia": "Prueba titular",
          "fecha_noticia": "2025-07-29 21:31:00",
          "id_estado": 1
        },
        {
          "id_noticia": 331,
          "titulo_noticia": "La tecnología debe servir a todas las personas y el planeta",
          "fecha_noticia": "2025-07-10 00:00:00",
          "id_estado": 1
        },
        {
          "id_noticia": 329,
          "titulo_noticia": "Día de la Bandera chilena: ¿qué significan sus colores y por qué tantos países también los tienen?",
          "fecha_noticia": "2025-07-10 00:00:00",
          "id_estado": 1
        },
        {
          "id_noticia": 319,
          "titulo_noticia": "Prueba noticia 0702",
          "fecha_noticia": "2025-02-07 09:00:00",
          "id_estado": 1
        },
        {
          "id_noticia": 320,
          "titulo_noticia": "nueva noticia",
          "fecha_noticia": "2025-02-07 03:00:00",
          "id_estado": 1
        },
        {
          "id_noticia": 321,
          "titulo_noticia": "Prueba notificacione spush",
          "fecha_noticia": "2025-02-07 00:00:00",
          "id_estado": 1
        },
        {
          "id_noticia": 317,
          "titulo_noticia": "Prueba 2",
          "fecha_noticia": "2025-01-26 21:00:00",
          "id_estado": 1
        },
        {
          "id_noticia": 318,
          "titulo_noticia": "Prueba Push",
          "fecha_noticia": "2025-01-26 18:00:00",
          "id_estado": 1
        },
        {
          "id_noticia": 316,
          "titulo_noticia": "Prueba de alerta push editada",
          "fecha_noticia": "2025-01-26 18:00:00",
          "id_estado": 1
        },
        {
          "id_noticia": 315,
          "titulo_noticia": "¿Qué es Kanban?",
          "fecha_noticia": "2024-09-22 19:00:00",
          "id_estado": 1
        },
        {
          "id_noticia": 314,
          "titulo_noticia": "Hola denuevo",
          "fecha_noticia": "2024-09-05 20:00:00",
          "id_estado": 1
        },
        {
          "id_noticia": 313,
          "titulo_noticia": "Chao mundo",
          "fecha_noticia": "2024-09-05 20:00:00",
          "id_estado": 1
        },
        {
          "id_noticia": 312,
          "titulo_noticia": "Hola mundo!!",
          "fecha_noticia": "2024-09-05 20:00:00",
          "id_estado": 1
        },
        {
          "id_noticia": 311,
          "titulo_noticia": "aa",
          "fecha_noticia": "2024-06-05 20:00:00",
          "id_estado": 1
        },
        {
          "id_noticia": 310,
          "titulo_noticia": "mi título",
          "fecha_noticia": "2024-03-17 21:00:00",
          "id_estado": 1
        },
        {
          "id_noticia": 309,
          "titulo_noticia": "Titulo de la notsadf",
          "fecha_noticia": "2024-03-14 21:00:00",
          "id_estado": 1
        },
        {
          "id_noticia": 308,
          "titulo_noticia": "Validando noticias",
          "fecha_noticia": "2023-12-21 10:05:00",
          "id_estado": 1
        },
        {
          "id_noticia": 307,
          "titulo_noticia": "Revisando notificaciones ",
          "fecha_noticia": "2023-08-10 16:00:00",
          "id_estado": 1
        },
        {
          "id_noticia": 306,
          "titulo_noticia": "última noticia ",
          "fecha_noticia": "2023-08-08 16:00:00",
          "id_estado": 1
        },
        {
          "id_noticia": 283,
          "titulo_noticia": "Probando ",
          "fecha_noticia": "2023-06-09 00:00:00",
          "id_estado": 1
        },
        {
          "id_noticia": 262,
          "titulo_noticia": "TEST push",
          "fecha_noticia": "2023-03-22 00:00:00",
          "id_estado": 1
        },
        {
          "id_noticia": 238,
          "titulo_noticia": "Noticias de hoy",
          "fecha_noticia": "2023-03-02 00:00:00",
          "id_estado": 1
        },
        {
          "id_noticia": 184,
          "titulo_noticia": "prueba edited",
          "fecha_noticia": "2022-11-17 00:00:00",
          "id_estado": 1
        },
        {
          "id_noticia": 124,
          "titulo_noticia": "Hola Test ",
          "fecha_noticia": "2022-06-24 09:00:00",
          "id_estado": 1
        },
        {
          "id_noticia": 129,
          "titulo_noticia": "Feliz día del Padre",
          "fecha_noticia": "2022-06-24 00:00:00",
          "id_estado": 1
        },
        {
          "id_noticia": 127,
          "titulo_noticia": "Feliz día del Padre",
          "fecha_noticia": "2022-06-24 00:00:00",
          "id_estado": 1
        },
        {
          "id_noticia": 123,
          "titulo_noticia": "Revisión general ",
          "fecha_noticia": "2022-06-23 00:00:00",
          "id_estado": 1
        },
        {
          "id_noticia": 122,
          "titulo_noticia": "Revisión",
          "fecha_noticia": "2022-06-23 00:00:00",
          "id_estado": 1
        }
      ]
    }
  }
*/